function e(e){let t=parseInt(e,10)||12;return t<12?12:t<26?t:t>100?50:26+Math.floor((t-26)/3)}export{e as toMobileFontSize};
//# sourceMappingURL=to-mobile-font-size.js.map